import { render, staticRenderFns } from "./Checkdown.vue?vue&type=template&id=4d63bb22&"
import script from "./Checkdown.vue?vue&type=script&lang=js&"
export * from "./Checkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports